/*
 * Urun basina siparis siniri.
 *
 * 22 Ekim 2026: once Canped'e duz 10 kondu, ayni gun her urune AYRI sinir
 * istendi (120'lik paketten 10 = 30'luktan 40). Sinir urunun meta alaninda
 * (custom.siparis_basina_en_fazla); kural snippets/nm-adet-siniri.liquid
 * icinde. /cart.js meta alani tasimadigi icin satirlarin sinirlari
 * /cart?view=nm-sinir sablonundan okunuyor (templates/cart.nm-sinir.liquid).
 *
 * Adet kutusu sinirin buyuk kismini zaten tutuyor: Liquid kutuya max yaziyor,
 * sepetteki adedi tema dusuyor (theme.js setQuantityBoundries). Bu dosya
 * kutunun yetmedigi yollari kapatiyor:
 *   - koleksiyon kartindaki "Sepete Ekle"ye sinirdan sonra yine basmak,
 *   - sepet sayfasinda adedi elle buyuk yazmak,
 *   - uygulamalarin kendi ekleme istekleri (Essential Upsell, LimeSpot),
 *   - sepete link ya da JS'siz form ile gelen fazla adet (sepet sayfasi acilinca).
 * Sepete yazan fetch istekleri (add / change / update) izleniyor; sinir asilirsa
 * satir sinira indiriliyor ve musteriye nedeni soyleniyor.
 *
 * Sunucu tarafi kilit DEGIL — Advanced planda kendi uygulamamizla kurulamiyor.
 * Odeme sayfasina dogrudan giden sepet linki (/cart/<varyant>:50) bunu atlar.
 */
(() => {
  const ayar = window.nmAdetSiniri;
  if (!ayar || !ayar.gorunum || typeof window.fetch !== 'function') return;

  const asilFetch = window.fetch.bind(window);

  const yollar = () => (window.FoxTheme && window.FoxTheme.routes) || {};
  const sepetYolu = () => (yollar().cart_url || '/cart').replace(/\/$/, '');
  const degisimYolu = () => yollar().cart_change_url || '/cart/change';

  const kural = (sinir) => `Bu üründen sipariş başına en fazla ${sinir} adet alınabilir.`;

  const jsonYanit = (veri, durum) =>
    new Response(JSON.stringify(veri), { status: durum, headers: { 'Content-Type': 'application/json' } });

  // Satirlar + sinirlari: [{ key, variant_id, product_id, quantity, title, sinir|null }]
  // Accept: application/json GONDERME: Shopify o zaman sablonu degil /cart.js
  // verisini donduruyor (sinir alani yok) ve her urun sinirsiz sanilir (olculdu).
  const sinirleriAl = async () => {
    const yanit = await asilFetch(`${sepetYolu()}?view=${encodeURIComponent(ayar.gorunum)}`, { cache: 'no-store' });
    const kalemler = JSON.parse(await yanit.text()).items || [];
    if (kalemler.some((s) => !('sinir' in s))) throw new Error('nm-sinir sablonu gelmedi');
    kalemler.forEach((s) => sinirsizHatirla(s));
    return kalemler;
  };

  // Siniri olmadigi bilinen urunlerde ekleme sonrasi sablon hic cekilmesin;
  // diger urunlerde ek istek olmasin. Oturum boyunca (sekme kapanana kadar).
  // Panelde sonradan sinir girilirse sepet sayfasi yine yakalar: orada her
  // seferinde taze okunuyor.
  const BILINEN = 'nm-adet-siniri-sinirsiz';
  let sinirsizlar;
  try {
    sinirsizlar = new Set(JSON.parse(sessionStorage.getItem(BILINEN) || '[]'));
  } catch (e) {
    sinirsizlar = new Set();
  }
  function sinirsizHatirla(satir) {
    const no = String(satir.product_id);
    if (satir.sinir == null) sinirsizlar.add(no);
    else sinirsizlar.delete(no);
    try {
      sessionStorage.setItem(BILINEN, JSON.stringify([...sinirsizlar].slice(-300)));
    } catch (e) {
      /* depolama kapali */
    }
  }

  /* ---------- bildirim (gorunumu theme.css'teki .nm-atc-toast) ---------- */

  let kutu = null;
  let zamanlayici = null;

  const gizle = () => {
    clearTimeout(zamanlayici);
    if (!kutu || kutu.hidden) return;
    kutu.classList.remove('is-acik');
    setTimeout(() => {
      if (!kutu.classList.contains('is-acik')) kutu.hidden = true;
    }, 200);
  };

  const zamanla = () => {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(gizle, 7000);
  };

  const uyar = (baslik, metin) => {
    if (!kutu) {
      kutu = document.createElement('div');
      kutu.className = 'nm-atc-toast nm-atc-toast--hata no-empty';
      kutu.setAttribute('role', 'alert');
      kutu.hidden = true;
      kutu.innerHTML = `
        <span class="nm-atc-toast__ikon" aria-hidden="true"></span>
        <span class="nm-atc-toast__metin">
          <strong class="nm-atc-toast__baslik"></strong>
          <span class="nm-atc-toast__urun"></span>
        </span>
        <button type="button" class="nm-atc-toast__kapat" aria-label="Kapat">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"></path></svg>
        </button>`;
      kutu.querySelector('.nm-atc-toast__kapat').addEventListener('click', gizle);
      kutu.addEventListener('mouseenter', () => clearTimeout(zamanlayici));
      kutu.addEventListener('mouseleave', zamanla);
      document.body.appendChild(kutu);
    }
    kutu.querySelector('.nm-atc-toast__baslik').textContent = baslik;
    kutu.querySelector('.nm-atc-toast__urun').textContent = metin;
    // Baslik yapiskan; bildirim onun hemen altinda dursun (nm-sepet-bildirim.js ile ayni).
    const baslikAlani = document.querySelector('.shopify-section-group-header-group header, header.header');
    const alt = baslikAlani ? baslikAlani.getBoundingClientRect().bottom : 0;
    kutu.style.setProperty('--nm-toast-top', `${Math.max(12, Math.round(alt) + 12)}px`);
    kutu.hidden = false;
    requestAnimationFrame(() => kutu.classList.add('is-acik'));
    zamanla();
  };

  /* ---------- sepet denetimi ---------- */

  const govdeOku = async (girdi, secenek) => {
    let govde = secenek && secenek.body;
    if (govde == null && girdi instanceof Request) govde = await girdi.clone().text();
    if (!govde) return {};
    if (typeof govde === 'string') {
      try {
        return JSON.parse(govde);
      } catch (e) {
        return Object.fromEntries(new URLSearchParams(govde));
      }
    }
    if (govde instanceof FormData || govde instanceof URLSearchParams) {
      const sonuc = {};
      govde.forEach((deger, anahtar) => {
        sonuc[anahtar] = deger;
      });
      return sonuc;
    }
    return {};
  };

  // Urun basina toplam sinirdan fazlaysa en yeni satirdan baslayarak indir
  // (Shopify en son eklenen satiri basta donduruyor). Istek bolum (sections)
  // istediyse duzeltme istegi de ayni bolumleri ister; cagiran guncel HTML'i alir.
  const duzelt = async (kalemler, istek) => {
    const urunler = new Map();
    kalemler.forEach((s) => {
      if (s.sinir == null) return;
      const u = urunler.get(s.product_id) || { sinir: s.sinir, toplam: 0 };
      u.toplam += s.quantity;
      urunler.set(s.product_id, u);
    });

    let son = null;
    let ilk = null;
    for (const [urunNo, u] of urunler) {
      let fazla = u.toplam - u.sinir;
      for (const satir of kalemler.filter((s) => s.product_id === urunNo)) {
        if (fazla <= 0) break;
        const dus = Math.min(fazla, satir.quantity);
        const govde = { id: satir.key, quantity: satir.quantity - dus };
        if (istek.sections) govde.sections = istek.sections;
        if (istek.sections_url) govde.sections_url = istek.sections_url;
        const yanit = await asilFetch(`${degisimYolu()}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(govde)
        });
        son = await yanit.json();
        fazla -= dus;
        ilk = ilk || satir;
      }
    }
    return { sepet: son, satir: ilk };
  };

  // Sepet sayfasinda adet elle yazilinca istek gitmeden bak. Tema hata donunce
  // kutuyu eski degerine cevirip mesaji kutunun ustunde gosteriyor (cart.js
  // onCartError -> setValidity), stok hatasindaki gibi.
  const degisimiDenetle = async (istek) => {
    const adet = parseInt(istek.quantity, 10);
    if (!(adet > 0)) return null;
    const kalemler = await sinirleriAl();
    const satir = istek.line
      ? kalemler[parseInt(istek.line, 10) - 1]
      : kalemler.find((s) => s.key === istek.id) || kalemler.find((s) => String(s.variant_id) === String(istek.id));
    if (!satir || satir.sinir == null || adet <= satir.quantity) return null;
    const diger = kalemler
      .filter((s) => s !== satir && s.product_id === satir.product_id)
      .reduce((t, s) => t + s.quantity, 0);
    if (adet + diger <= satir.sinir) return null;
    const mesaj = kural(satir.sinir);
    return jsonYanit({ status: 422, message: mesaj, description: mesaj, errors: mesaj }, 422);
  };

  const sonradanDenetle = async (tur, istek, yanit) => {
    const veri = await yanit.clone().json();
    if (tur === 'add') {
      // Ekleme yaniti yalnizca eklenen satirlari donduruyor. Hepsinin siniri
      // olmadigi biliniyorsa sablonu cekme. Hata yanitinda (stok) Shopify yine
      // de eklenebileni ekliyor, o yuzden bakiliyor.
      const eklenen = veri.items || (veri.variant_id ? [veri] : []);
      if (yanit.ok && eklenen.every((s) => sinirsizlar.has(String(s.product_id)))) return yanit;
    } else if (!yanit.ok || !Array.isArray(veri.items)) {
      return yanit;
    }

    const { sepet: yeni, satir } = await duzelt(await sinirleriAl(), istek);
    if (!satir) return yanit;
    const mesaj = `${kural(satir.sinir)} Sepetinizde bu üründen ${satir.sinir} adet var.`;

    if (tur === 'add') {
      // Shopify stoktan fazla istenince de boyle yapiyor: eklenebileni ekleyip
      // 422. nm-sepet-bildirim.js 422'de "Dikkat" + bu cumleyi gosteriyor.
      return jsonYanit({ status: 422, message: 'Cart Error', description: mesaj, sections: yeni && yeni.sections }, 422);
    }
    uyar('Adet düzeltildi', mesaj);
    return jsonYanit(yeni, 200);
  };

  const istekTuru = (girdi) => {
    let adres;
    try {
      adres = new URL(girdi instanceof Request ? girdi.url : String(girdi), location.href);
    } catch (e) {
      return null;
    }
    if (adres.origin !== location.origin) return null;
    const eslesme = adres.pathname.match(/\/cart\/(add|change|update)(?:\.js(?:on)?)?\/?$/);
    return eslesme ? eslesme[1] : null;
  };

  window.fetch = async function (girdi, secenek) {
    const tur = istekTuru(girdi);
    const yontem = String((secenek && secenek.method) || (girdi instanceof Request ? girdi.method : 'GET'));
    if (!tur || yontem.toUpperCase() !== 'POST') return asilFetch(girdi, secenek);

    // Denetim hata verirse musteriyi durdurma: istek oldugu gibi gider. Istek
    // gittikten sonra ASLA yeniden gonderme (ekleme iki kez olur).
    let istek = {};
    try {
      istek = await govdeOku(girdi, secenek);
      if (tur === 'change') {
        const engel = await degisimiDenetle(istek);
        if (engel) return engel;
      }
    } catch (e) {
      /* denetimsiz devam */
    }
    const yanit = await asilFetch(girdi, secenek);
    try {
      return await sonradanDenetle(tur, istek, yanit);
    } catch (e) {
      return yanit;
    }
  };

  /* ---------- adet kutusu ---------- */

  // Sepette zaten sinir kadar varsa tema kutuyu 0 yapip ust siniri kaldiriyor
  // (setQuantityBoundries'te `if (max)` 0'i yok sayiyor), arti dugmesi acik
  // kaliyor. Kutuyu 1'de kilitle; "Sepete Ekle"ye basilirsa yukaridaki denetim
  // satiri sinirda tutup nedenini soyluyor.
  const kutulariKilitle = () => {
    document.querySelectorAll('input.quantity__input[data-nm-adet-siniri][data-max]').forEach((girdi) => {
      const kalan = parseInt(girdi.dataset.max, 10) - (parseInt(girdi.dataset.cartQuantity, 10) || 0);
      if (kalan > 0) return;
      girdi.min = 1;
      girdi.max = 1;
      girdi.value = 1;
      const kutuEl = girdi.closest('quantity-input');
      if (kutuEl) kutuEl.querySelectorAll('button[name="plus"], button[name="minus"]').forEach((d) => d.setAttribute('disabled', ''));
    });
  };

  // Sepete link ya da JS'siz form ile fazla adet gelmis olabilir: sepet sayfasi acilinca bak.
  const sepetSayfasiniDenetle = async () => {
    if (location.pathname.replace(/\/$/, '') !== sepetYolu()) return;
    const bolumler = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: bolumler } })
    );
    const { sepet, satir } = await duzelt(await sinirleriAl(), bolumler.length ? { sections: bolumler } : {});
    const BAYRAK = 'nm-adet-siniri-yenilendi';
    if (!satir) {
      try {
        sessionStorage.removeItem(BAYRAK);
      } catch (e) {
        /* depolama kapali */
      }
      return;
    }
    const tema = window.FoxTheme;
    if (!sepet || !sepet.sections || !tema || !tema.pubsub) {
      // Sayfa yenilenince sepet guncel gelir. Bir kez: duzeltme tutmadiysa dongu olmasin.
      try {
        if (sessionStorage.getItem(BAYRAK)) return;
        sessionStorage.setItem(BAYRAK, '1');
      } catch (e) {
        return;
      }
      location.reload();
      return;
    }
    tema.pubsub.publish(tema.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: sepet });
    uyar('Adet düzeltildi', `“${satir.title}” ${satir.sinir} adede indirildi. ${kural(satir.sinir)}`);
  };

  const basla = () => {
    kutulariKilitle();
    const tema = window.FoxTheme;
    if (tema && tema.pubsub) tema.pubsub.subscribe(tema.pubsub.PUB_SUB_EVENTS.quantityUpdate, kutulariKilitle);
    sepetSayfasiniDenetle().catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
